import { useState } from 'react';
import { Container, Grid } from '@mui/material';
import '../styles.scss';

export default function Pregunta14({ setRespuesta, respuestas, puntos, sumarPuntos, guardar }) {
	const [seleccionadas, setSeleccionada] = useState([]);
	const [btn1, setBtn1] = useState(false);
	const [btn2, setBtn2] = useState(false);
	const [btn3, setBtn3] = useState(false);
	const [btn4, setBtn4] = useState(false);
	const [correctas] = useState(['a) Usar Mentimeter para recolectar opiniones y Kahoot para la actividad competitiva.']);

	const grabarSeleccionada = (opc) => {
		const array = seleccionadas;
		array.push(opc);
		array.sort();
		setSeleccionada(array);
	};

	const siguiente = () => {
		let suma = puntos;
		let json = {};
		console.log(respuestas);

		if (seleccionadas.toString() === correctas.toString()) {
			json = { ...respuestas, pregunta15: seleccionadas };
			console.log('si');
			sumarPuntos(1);
		} else {
			json = { ...respuestas, pregunta15: seleccionadas };
			console.log('no');
			sumarPuntos(0);
		}
		sessionStorage.setItem('respuestas', JSON.stringify(json));

		setTimeout(() => {
			guardar();
		}, 500);
	};

	const seleccionarOpcion = (btn) => {
		if (btn === 1) {
			setBtn1(!btn1);
			setBtn2(false);
			setBtn3(false);
			setBtn4(false);
		}
		if (btn === 2) {
			setBtn1(false);
			setBtn2(!btn2);
			setBtn3(false);
			setBtn4(false);
		}
		if (btn === 3) {
			setBtn1(false);
			setBtn2(false);
			setBtn3(!btn3);
			setBtn4(false);
		}
	};

	return (
		<>
			<Container maxWidth='lg'>
				<Grid container justifyContent='center' alignItems='center' spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='pregunta'>
							<div className='num-pregunta'>15.</div>
							<div>
								<div>Estás organizando una sesión de capacitación para tus Asesores y quieres mantenerlos comprometidos e involucrados, por lo que, para dicha sesión: </div>
								<p>1. Recolectar opiniones rápidas sobre cómo manejan ciertas situaciones con los clientes.</p>
								<p>2. Diseñar una actividad final divertida para evaluar sus aprendizajes de manera competitiva.</p>
								<p>¿Qué herramientas utilizarías para lograr ambos propósitos?</p>
							</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn1 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								seleccionarOpcion(1);
								grabarSeleccionada('a) Usar Mentimeter para recolectar opiniones y Kahoot para la actividad competitiva.');
							}}
						>
							<div className='letra'>{`a)`}</div>
							<div className='texto-respuesta'>Usar Mentimeter para recolectar opiniones y Kahoot para la actividad competitiva.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn2 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								seleccionarOpcion(2);
								grabarSeleccionada('b) Usar Mindomo para ambos propósitos, ya que es más versátil.');
							}}
						>
							<div className='letra'>{`b)`}</div>
							<div className='texto-respuesta'>Usar Mindomo para ambos propósitos, ya que es más versátil.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn3 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								seleccionarOpcion(3);
								grabarSeleccionada('c) Usar EDpuzzle para ambos propósitos, ya que fomenta la interacción.');
							}}
						>
							<div className='letra'>{`c)`}</div>
							<div className='texto-respuesta'> Usar EDpuzzle para ambos propósitos, ya que fomenta la interacción.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='siguiente' onClick={() => siguiente()}>
							Terminar
						</div>
					</Grid>
				</Grid>
			</Container>
		</>
	);
}
